import React from 'react';
import './FooterControls.css';

/**
 * Componente puramente apresentacional.
 * uiMode: 'points' | 'ledIdle' | 'ledEditing'
 */
export default function FooterControls({
  uiMode,

  // grupos (pontos e leds)
  circleNumber = 1,
  canDecrease = false,
  onPrevNumber = () => {},
  onNextNumber = () => {},
  onNextSlot, // ainda não usado aqui, mas pode ser usado no futuro

  // LED (modes: 'ledIdle' e 'ledEditing')
  canCommitLed = false,
  onLedCancel = () => {},
  onLedCommit = () => {},

  // mensagem opcional para o ledIdle
  ledIdleHint = 'Modo LED: clique na planta para começar a desenhar a fita',
}) {
  // Evita que cliques nos botões atinjam o canvas
  const stop = (e) => e.stopPropagation();

  // === LED EDITANDO: só cancelar/concluir ===
  if (uiMode === 'ledEditing') {
    return (
      <div className="canvas-info led-mode minimal" onClick={stop}>
        <div className="info-controls led-controls">
          <button
            className="quick-btn led-cancel"
            onClick={onLedCancel}
            title="Cancelar edição da fita LED"
            aria-label="Cancelar edição da fita LED"
          >
            ✕ Cancelar
          </button>

          <button
            className="quick-btn led-finish"
            onClick={onLedCommit}
            disabled={!canCommitLed}
            title="Concluir fita LED (atalho: Enter)"
            aria-label="Concluir fita LED"
          >
            ✓ Concluir
          </button>
        </div>
      </div>
    );
  }

  // === POINTS ou LED IDLE: mesma UI de número de grupo ===
  if (uiMode === 'points' || uiMode === 'ledIdle') {
    const isLedIdle = uiMode === 'ledIdle';

    return (
      <div
        className={`canvas-info minimal ${isLedIdle ? 'led-idle' : ''}`}
        onClick={stop}
      >
        <div className="info-controls minimal-controls">
          <button
            className="quick-btn decrease"
            onClick={onPrevNumber}
            disabled={!canDecrease}
            title="Grupo anterior"
            aria-label="Grupo anterior"
          >
            ←
          </button>

          <div
            className="number-badge"
            title="Número atual do grupo"
            aria-live="polite"
          >
            {circleNumber}
          </div>

          <button
            className="quick-btn increase"
            onClick={onNextNumber}
            title="Próximo grupo"
            aria-label="Próximo grupo"
          >
            →
          </button>
        </div>

        {isLedIdle && ledIdleHint && (
          <div className="hint-badge" aria-live="polite">
            {ledIdleHint}
          </div>
        )}
      </div>
    );
  }

  // fallback (se algum dia tiver outro uiMode)
  return null;
}